import { LOADING } from "./actionItem"

export const loading=()=>{
    return {type:LOADING}
}